import type { ReactElement } from 'react'
import { Navigate } from 'react-router-dom'

import { FeatureFlagKeys } from '@hapana/shared/constants/feature-flag.constants'
import { useAwaitedFeatureFlag } from '_hooks/use-awaited-feature-flag.hooks'

import { ROUTES } from '../../../app.constants'

type ClassCoversBrandRouteGuardProps = {
  children: ReactElement
}

const ClassCoversBrandRouteGuard = ({ children }: ClassCoversBrandRouteGuardProps) => {
  const isEnabled = useAwaitedFeatureFlag(FeatureFlagKeys.ClassCoversEnabled)
  if (isEnabled === null) {
    return null
  }
  if (!isEnabled) {
    return <Navigate to={`/c/${ROUTES.controlCenter.path}`} replace />
  }
  return children
}

export default ClassCoversBrandRouteGuard
